<template>
  <section class="itb-hero-cards">
    <div class="container">
      <div
        v-for="card in cards"
        v-if="card.type == 'left' || card.type == 'right'"
        class="itb-hero-card row d-flex align-content-center mx-0 itb-lazy-loading-bg"
        v-lazy:background-image="
          card.bg_image && !isResponsive
            ? setBackgroundImage(card)
            : '/images/articles/blank-bg.webp'
        "
        style="background-size: cover"
      >
        <div
          v-if="isResponsive"
          class="itb-hero-responsive-image"
          v-lazy:background-image="
            card.bg_image ? setBackgroundImage(card) : null
          "
        ></div>
        <div class="col-12 px-0">
          <div
            class="itb-card"
            :class="{
              'ml-auto right': card.type == 'right',
              'itb-card-bg-blue': cardColor == 'blue',
              'itb-card-bg-orange': cardColor == 'orange',
              'itb-playhop-hero-custom':
                card.title == 'playhop.hero_cards.title_1',
              'd-flex flex-column':
                card.title == 'cleaning.hero_cards.title_2' ||
                card.title == 'cleaning.hero_cards.title_4',
            }"
            :style="card.card_styles ? card.card_styles : ''"
          >
            <h2 v-if="card.title" v-html="setTitle(card)"></h2>
            <div v-if="card.isDynamic">
              <p>{{ card.texts }}</p>

              <p class="itb-font-black">
                <span class="itb-32-text">
                  {{ $t("playgrounds.price") + ": " + card.budget }}
                </span>
              </p>
            </div>
            <div
              v-if="!card.isDynamic"
              v-html="$t('constants.' + card.texts)"
            ></div>

            <button
              v-if="
                card.button_type == 'contact-form' ||
                card.button_type == 'scroll'
              "
              class="btn itb-btn-icon"
              :class="{
                'btn-primary': cardColor == 'blue',
                'btn-secondary': cardColor == 'orange',
                'align-self-end':
                  card.title == 'cleaning.hero_cards.title_2' ||
                  card.title == 'cleaning.hero_cards.title_4',
              }"
              @click="
                scrollToElement(
                  card.scroll_to ? card.scroll_to : 'itb-contact-form'
                )
              "
            >
              {{
                $t(
                  card.link_text
                    ? card.link_text
                    : "realizations.i_want_proposal_free"
                )
              }}
              <img
                :src="buttonImage(card).url"
                :alt="$t('realizations.i_want_proposal_free')"
                :class="buttonImage(card).className"
              />
            </button>
            <router-link
              v-else-if="card.button_type == 'references'"
              :to="{
                name: 'realizationsByCategory',
                params: {
                  categoryAlias: $t('constants.' + card.link),
                },
              }"
              class="btn itb-btn-icon"
              :class="card.type == 'right' ? 'btn-primary' : 'btn-secondary'"
            >
              {{ $t("realizations.show_realizations") }}
              <img
                src="/images/icons/4soft_icon_angle-right.svg"
                :alt="
                  $t('general.button') +
                  ' ' +
                  $t('realizations.show_realizations')
                "
                class="itb-icon itb-angle-right-icon"
              />
            </router-link>
            <a
              v-else-if="card.link"
              class="btn itb-btn-icon"
              :class="card.type == 'right' ? 'btn-primary' : 'btn-secondary'"
              :href="card.isDynamic ? card.link : $t(card.link)"
              target="_blank"
            >
              {{ $t(card.link_text) }}
              <img
                src="/images/icons/4soft_icon_angle-right.svg"
                :alt="$t('constants.' + card.link_text)"
                class="itb-icon itb-angle-right-icon"
              />
            </a>

            <button
              v-if="
                card.button_type_2 == 'contact-form' ||
                card.button_type_2 == 'scroll'
              "
              class="btn itb-btn-icon ml-4"
              :class="card.type == 'right' ? 'btn-primary' : 'btn-secondary'"
              @click="
                scrollToElement(
                  card.scroll_to_2 ? card.scroll_to_2 : 'itb-contact-form'
                )
              "
            >
              {{
                $t(
                  card.link_text_2
                    ? card.link_text_2
                    : "realizations.i_want_proposal_free"
                )
              }}
              <img
                src="/images/icons/4soft_icon_angle-down.svg"
                :alt="$t('realizations.i_want_proposal_free')"
                class="itb-icon itb-angle-down-icon"
              />
            </button>
            <router-link
              v-else-if="card.button_type_2 == 'references'"
              :to="{
                name: 'realizationsByCategory',
                params: {
                  categoryAlias: $t('constants.' + card.link_2),
                },
              }"
              class="btn itb-btn-icon ml-4"
              :class="card.type == 'right' ? 'btn-primary' : 'btn-secondary'"
            >
              {{ $t("realizations.show_realizations") }}
              <img
                src="/images/icons/4soft_icon_angle-right.svg"
                :alt="
                  $t('general.button') +
                  ' ' +
                  $t('realizations.show_realizations')
                "
                class="itb-icon itb-angle-right-icon"
              />
            </router-link>
            <a
              v-else-if="card.link_2"
              class="btn itb-btn-icon ml-4"
              :class="card.type == 'right' ? 'btn-primary' : 'btn-secondary'"
              :href="$t(card.link_2)"
              target="_blank"
            >
              {{ $t(card.link_text_2) }}
              <img
                src="/images/icons/4soft_icon_angle-right.svg"
                :alt="$t('constants.' + card.link_text_2)"
                class="itb-icon itb-angle-right-icon"
              />
            </a>
            <a
              v-else-if="card.link_3"
              class="btn itb-btn-icon ml-4"
              :class="{
                'btn-primary': cardColor == 'blue',
                'btn-secondary': cardColor == 'orange',
                'align-self-end':
                  card.title == 'cleaning.hero_cards.title_2' ||
                  card.title == 'cleaning.hero_cards.title_4',
              }"
              :href="card.link_3"
              :download="card.link_3 != '#itb-contact-form' ? '' : false"
            >
              {{ $t(card.link_text_3) }}
              <img
                src="/images/icons/4soft_icon_angle-right.svg"
                :alt="$t('constants.' + card.link_text_3)"
                class="itb-icon itb-angle-right-icon"
              />
            </a>
          </div>
        </div>
      </div>
      <div
        v-else-if="card.type == 'grey'"
        class="itb-hero-card itb-grey row mx-0"
      >
        <div class="col-12">
          <h2
            v-html="$t('constants.' + card.title)"
            :class="!card.subtitle ? 'mb-4' : 0"
          ></h2>
          <h3
            v-if="card.subtitle"
            v-html="$t('constants.' + card.subtitle)"
          ></h3>
          <div class="row">
            <div
              class="col-12 col-md-6 itb-left"
              v-html="$t('constants.' + card.texts_a)"
            ></div>
            <div
              class="col-12 col-md-6 itb-right"
              v-html="$t('constants.' + card.texts_b)"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HeroCardsColorSet",
  props: {
    cards: Array,
    cardColor: String,
  },

  data() {
    return {
      isResponsive: false,
    };
  },

  created() {
    this.onResize();
    window.addEventListener("resize", this.onResize);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },

  methods: {
    scrollToElement(elementId) {
      this.$parent.scrollToElement(elementId);
    },
    onResize() {
      if (window.innerWidth < 992) {
        this.isResponsive = true;
      } else {
        this.isResponsive = false;
      }
    },

    setBackgroundImage(card) {
      let backgroundImage;
      if (card.isDynamic) {
        backgroundImage = "/uploads/" + card.bg_image;
      } else {
        backgroundImage = "/images/articles/" + card.bg_image;
      }

      return backgroundImage;
    },

    setTitle(card) {
      let title;
      if (card.isDynamic) {
        title = card.title;
      } else {
        title = this.$t("constants." + card.title);
      }

      return title;
    },

    setTexts(card) {
      let texts;
      if (card.isDynamic) {
        texts = "<p>" + card.texts + "</p>";
      } else {
        texts = this.$t("constants." + card.texts);
      }

      return texts;
    },

    buttonImage(card) {
      let imageUrl = "/images/icons/4soft_icon_angle-down.svg";
      let imageClass = "itb-icon itb-angle-down-icon";

      if (card.hasOwnProperty("button_icon")) {
        imageUrl = "/images/icons/4soft_icon_" + card.button_icon + ".svg";
        imageClass = "itb-icon itb-" + card.button_icon + "-icon";
      }

      return { url: imageUrl, className: imageClass };
    },
  },
};
</script>
